import { render, staticRenderFns } from "./HistoryBloodPressure.vue?vue&type=template&id=04d5e706&scoped=true&"
import script from "./HistoryBloodPressure.vue?vue&type=script&lang=js&"
export * from "./HistoryBloodPressure.vue?vue&type=script&lang=js&"
import style0 from "./HistoryBloodPressure.vue?vue&type=style&index=0&id=04d5e706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5e706",
  null
  
)

export default component.exports